export * from './BarChartPro';
export * from './BarChartPro.plugins';
